import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: "#0077ff",
            light: "#4da3ff",
            dark: "#0055cc",
            contrastText: "#fff",
        },
        secondary: {
            main: "#00e5a0",
            contrastText: "#000",
        },
        background: {
            default: "#0a0c0f",
            paper: "#111318",
        },
        text: {
            primary: "#f0f2f5",
            secondary: "#8a92a0",
        },
        divider: "rgba(255,255,255,0.07)",
    },
    typography: {
        fontFamily: `'DM Sans', 'Helvetica', 'Arial', sans-serif`,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        h1: { fontFamily: `'Fraunces', serif`, fontWeight: 300 },
        h2: { fontFamily: `'Fraunces', serif`, fontWeight: 300 },
        h3: { fontFamily: `'Fraunces', serif`, fontWeight: 300 },
        h4: { fontFamily: `'Fraunces', serif`, fontWeight: 300 },
        h5: { fontFamily: `'Fraunces', serif`, fontWeight: 600 },
        h6: { fontFamily: `'Fraunces', serif`, fontWeight: 600 },
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    background: "rgba(10,12,15,0.9)",
                    backdropFilter: "blur(12px)",
                    borderBottom: "1px solid rgba(255,255,255,0.07)",
                    boxShadow: "none",
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: "none",
                    border: "1px solid rgba(255,255,255,0.07)",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: `'DM Mono', monospace`,
                    fontSize: "11px",
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontFamily: `'DM Mono', monospace`,
                    fontSize: "10px",
                    letterSpacing: "0.05em",
                    border: "1px solid rgba(255,255,255,0.13)",
                    background: "transparent",
                },
            },
        },
    },
});

export default theme;
